import { fn as o } from "../common.js";
import { EMPTY_OBJECT as e } from "../value/constants.js";
import { truthify as r } from "../value/bool.js";
import { isPlainObject as i } from "../value/is.js";
const c = (t, n = e) => i(t) ? t : c(n, e), f = o(Object.create, void 0), u = o(f, void 0, null), O = (t = e) => Object.freeze({ ...t, defineProperty: r, set: r });
export {
  c as asPlainObject,
  u as struct,
  f as structFrom,
  O as withFreezeProxyHandlers
};
